import { CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation } from '@festina/life-general-types/life/hooks/CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation'

export const useLazyFetchCommitmentVersionSimulationSensitive =
  CommitmentSourcesSimulateSensitiveService_commitmentSourcesSensitiveSimulateServicePostSimulation.useLazyQuery
